<template>
  <div class="container-fluid">
    <div v-if="!hasFields()" class="row">
      <div class="col-12 text-center">
        <div class="p-t-40">
          <h3 class="">
            You don't have any fields added yet.
          </h3>
          <button class="btn btn-lg btn-stem" @click="addField()">
            <i class="fas fa-plus" />&nbsp; Add Field
          </button>
        </div>
      </div>
    </div>

    <div v-if="hasFields()" class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-11">
            <h4 class="m-b-0">
              Fields
            </h4>
            <p class="text-muted m-t-0">
              List of fields
            </p>
          </div>
          <div class="col-1 text-right">
            <div class="form-group">
              <select id="year" v-model="year" class="form-control" name="year" @change="yearChangeHandler">
                <option v-for="(year,index) in yearList" :key="index" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div v-for="(field, index) in fieldList" :key="index" class="card">
              <div class="card-body border-top border-bottom">
                <div class="row m-b-0">
                  <div class="col-lg-2 col-md-3">
                    <div class="d-flex align-items-center">
                      <div>
                        <span>Name</span>
                        <h3 class="font-medium m-b-0">
                          {{ field.name }}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3">
                    <div class="d-flex align-items-center">
                      <div>
                        <span>Location</span>
                        <h3>{{ field.location }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3">
                    <div class="d-flex align-items-center">
                      <div>
                        <span>Area</span>
                        <h3>{{ field.area.amount }} {{ field.area.units }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3">
                    <div class="d-flex align-items-center">
                      <div>
                        <span>Cadastral Plot</span>
                        <h3>{{ field.cadastral_plot }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3">
                    <div class="d-flex align-items-center">
                      <div>
                        <span>Soil</span>
                        <h3>{{ field.soil.text }}</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-3">
                    <div class="d-flex ml-auto">
                      <div>
                        <span>Ownership Type</span>
                        <h3>{{ field.ownership.text }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row m-b-0">
                  <div class="col-lg-6 col-md-12">
                    <div v-if="field.crops.length > 0" class="table-responsive p-1">
                      <table class="table">
                        <thead class="bg-success text-white ">
                          <tr>
                            <th scope="col">
                              Crop
                            </th>
                            <th scope="col">
                              Area
                            </th>
                            <th scope="col" />
                          </tr>
                        </thead>
                        <tbody class="border border-success">
                          <tr v-for="(crop, index) in field.crops" :key="index">
                            <td>{{ crop.crops.name }}</td>
                            <td>{{ crop.area.amount }} &nbsp; {{ crop.area.units }}</td>
                            <td>
                              <button type="button" class="btn waves-effect waves-light btn-outline-danger btn-xs" @click="deleteCrop(crop)">
                                <i class="fa fa-minus" />
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="card-header">
                      <h4 class="card-title text-muted">
                        No crops are planned for this field for the selected year.
                      </h4>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-12">
                    <div class="card-header">
                      <h4 class="card-title">
                        New Crop
                      </h4>
                      <h6 class="card-subtitle">
                        Add a new crop for the selected year.
                      </h6>
                    </div>
                    <form class="form-horizontal" @submit.prevent="handleSubmit($event, field)">
                      <div class="form-group row">
                        <label for="crop" class="col-sm-2 text-right control-label col-form-label">Crop</label>
                        <div class="col-sm-8">
                          <multiselect id="crop" v-model="crop.crops" v-validate="'required'" name="crop" :options="cropList" class="form-control" label="name" track-by="name" placeholder="Select a crop" data-vv-as="Crop" :class="{'is-invalid': submitted && errors.has('crop')}" />
                          <div v-if="submitted && errors.has('crop')" class="invalid-feedback">
                            {{ errors.first('crop') }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="area" class="col-sm-2 text-right control-label col-form-label">Area ({{ field.area.units }})</label>
                        <div class="col-sm-4">
                          <div class="input-group">
                            <input id="area" v-model="crop.area.amount" v-validate="'required'" type="text" class="form-control" name="area" placeholder="Area" data-vv-as="Area" :class="{'is-invalid': submitted && (errors.has('area'))}">
                            <div v-if="submitted && errors.has('area')" class="invalid-feedback">
                              {{ errors.first('area') }}
                            </div>
                          </div>
                        </div>
                        <!--<div class="col-sm-3">-->
                        <!--<span>{{field.area.units}}</span>-->
                        <!--</div>-->
                      </div>
                      <div class="form-group m-b-0 text-right">
                        <div class="button-group col-sm-10 p-r-0">
                          <button type="submit" class="btn waves-effect waves-light btn-success">
                            Save
                          </button>
                          <button type="button" class="btn waves-effect waves-light btn-secondary m-r-0" @click="reset()">
                            Reset
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'CropPlanner',
  components: { Multiselect },
  data () {
    return {
      fieldList: [],
      crop: {
        fieldId: '',
        year: '',
        crops: '',
        area: {
          amount: '',
          units: ''
        }
      },
      submitted: false,
      soilTypes: [
        { value: 'CLAY', text: 'Clay' },
        { value: 'CLAY_LOAM', text: 'Clay Loam' },
        { value: 'SAND', text: 'Sand' },
        { value: 'LOAM', text: 'Loam' },
        { value: 'LOAMY_SAND', text: 'Loamy Sand' },
        { value: 'SANDY_CLAY', text: 'Sandy Clay' },
        { value: 'SANDY_CLAY_LOAM', text: 'Sandy Clay Loam' },
        { value: 'SILT', text: 'Silt' },
        { value: 'SILT_LOAM', text: 'Silt Loam' },
        { value: 'SILT_CLAY', text: 'Silty Clay' },
        { value: 'SILT_CLAY_LOAM', text: 'Silty Clay Loam' }
      ],
      ownershipTypes: [
        { value: 'PRIVATELY_OWNED', text: 'Privately Owned' },
        { value: 'LEASE', text: 'Lease' },
        { value: 'GIVEN_FOR_USE', text: 'Given for Use' },
        { value: 'PROPERTY_MANAGER', text: 'Property Manager' },
        { value: 'OWNED_BY_RELATIVES', text: 'Owned by Relatives' },
        { value: 'MIXED', text: 'Mixed' },
        { value: 'OTHER', text: 'Other' }
      ],
      cropList: [],
      yearList: [],
      year: (new Date()).getFullYear()
    }
  },
  mounted () {
    this.getFieldList()
    this.getCropList()
  },
  methods: {
    addField () {
      this.$router.push({ name: 'newfield' })
    },
    hasFields () {
      return this.fieldList.length > 0
    },
    async getFieldList () {
      const reply = await this.$api.get('/fields/planner', {
        params: {
          year: this.year
        }
      })
      this.fieldList = reply.data
      this.fieldList.map(field => {
        field.soil = this.soilTypes.find(r => r.value === field.soil)
        field.ownership = this.ownershipTypes.find(r => r.value === field.ownership)
      })

      const currentYear = (new Date()).getFullYear()
      this.yearList = []
      for (var i = 0; i < 5; i++) {
        this.yearList.push(parseInt(currentYear) + i)
      }
    },
    handleSubmit (e, field) {
      this.submitted = true
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.save(field)
          }
        })
    },
    async save (field) {
      const amount = parseInt(this.crop.area.amount)
      let spentAmount = 0
      const selectedCrop = this.crop.crops.name
      let isCropExist = false

      field.crops.forEach(function (element) {
        spentAmount += element.area.amount
        if (element.crops.name === selectedCrop) {
          isCropExist = true
        }
      })

      const remainingArea = field.area.amount - spentAmount
      if (amount <= remainingArea && amount > 0 && isCropExist === false) {
        this.crop.fieldId = field.id
        this.crop.area.units = field.area.units
        this.crop.year = this.year

        this.crop.area.amount = parseInt(amount)
        await this.$api.put(`/fields/${this.crop.fieldId}/planner`, this.crop)
        this.$toastr('success', 'New crops added successfully.', 'Crops Saved')
        this.reset()
        this.getFieldList()
      } else {
        this.$toastr('error', 'There is no such available area or selected crop is already exist', 'Failure!!!')
      }
    },
    reset () {
      this.submitted = false
      this.crop = {
        fieldId: '',
        year: '',
        crops: '',
        area: {
          amount: '',
          units: ''
        }
      }
    },
    yearChangeHandler () {
      this.getFieldList()
    },
    async deleteCrop (crop) {
      const cropId = crop.id
      const fieldId = crop.field_id
      await this.$api.delete(`/fields/${fieldId}/planner/${cropId}`)
      this.$toastr('success', 'New crops deleted successfully.', 'Crops Deleted')
      this.getFieldList()
    },
    async getCropList () {
      const reply = await this.$api.get('/fields/crops', {})
      this.cropList = reply.data
    }
  }
}
</script>

<style scoped>
</style>
